// The page a client opens from an Instagram invite link (hub de clientes,
// item 4): `/convite/instagram/<token>`. Pure, like `pre-auth-route`, so the
// branch that decides what a stranger's browser sees is testable without one.

const INVITE_PATH_RE = /^\/convite\/instagram\/([A-Za-z0-9_-]+)\/?$/u;

/** The invite token in this path, or null when the path is not an invite. */
export function instagramInviteTokenFromPath(pathname: string): string | null {
  return INVITE_PATH_RE.exec(pathname)?.[1] ?? null;
}

/** Browser entry point; null during static export. */
export function currentInstagramInviteToken(): string | null {
  if (typeof window === 'undefined') return null;
  return instagramInviteTokenFromPath(window.location.pathname);
}
